import { render } from "./ComponenteResultadosEcon.vue?vue&type=template&id=15cd1cd2"
import script from "./ComponenteResultadosEcon.vue?vue&type=script&lang=js"
export * from "./ComponenteResultadosEcon.vue?vue&type=script&lang=js"

import "./ComponenteResultadosEcon.vue?vue&type=style&index=0&id=15cd1cd2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__